import React from 'react';
import { Container, Title, Info, AnimatedLoaderContainer, AnimatedLoader, } from './ApplicationLoader.styled';
export const ApplicationLoader = ({ title = '', info = '', image = '/addi.svg', loaderHeight = 0, }) => {
    return (React.createElement(Container, { loaderHeight: loaderHeight },
        React.createElement(AnimatedLoaderContainer, { image: image },
            React.createElement(AnimatedLoader, { src: '/loader.svg', alt: 'addi-loader' })),
        React.createElement(Title, null, title),
        info && React.createElement(Info, null, info)));
};
//# sourceMappingURL=index.js.map